module.exports = __webpack_public_path__ + "bef1d39701d8de864c0a0aafbbae67a1.png";